export default "__VITE_ASSET__BuPlrTxL__"